module.exports = __webpack_public_path__ + "img/neo-app-mastercard.4e1f3c60.png";